import { belongsTo, hasMany, attr } from '@ember-data/model';
import ShModel from './sh-model';
import { computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { memberAction } from 'ember-api-actions';

export default ShModel.extend({
  name: attr('string'),
  description: attr('string'),
  userId: attr('number'),

  // Relationships

  memberships: hasMany('shGroupMember', { async: false }),
  members: hasMany('user', { async: false }),
  allMembers: hasMany('user', { async: false }), //Grabs all members, even those who have been "soft-deleted"
  owner: belongsTo('user', { async: false }),

  // Custom endpoints
  duplicate: memberAction({path: 'duplicate', type: 'post'}),

  // Custom properties
  belongsToCurrentUser: computed('userId', 'session.currentUser.id', function(){
    return this.get('session.currentUser.id') === `${this.get('userId')}`;
  })
});
